import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, OutlinedInput, Stack } from '@mui/material';
import { PageHeader } from '../../components/PageHeader';
import { CreativeTable } from './CreativeTable';
import { useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useNavigate } from 'react-router-dom';
import { useStudyContext } from '../../context';
export const CreativeManagementIndexPage = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const { resetStudyData } = useStudyContext();
    useEffect(() => {
        resetStudyData();
    }, []);
    const navigateToPreTestingPage = (id) => {
        console.log(`Navigating to pre-testing page with ID: ${id}`);
        navigate(`/studies/${id}`);
    };
    return (_jsxs(Box, { padding: "20px", paddingLeft: "30px", boxSizing: "border-box", children: [_jsx(PageHeader, { title: "AI Creative Pre-testing", breadcrumbs: [
                    { label: 'AI Creative Pre-testing', href: '/' },
                ], subtitle: "Run AI-based studies to pre-test your creatives effectiveness and optimize before running a campaign" }), _jsxs(Stack, { direction: 'row', justifyContent: 'right', margin: '20px 0', spacing: 2, children: [_jsx(OutlinedInput, { disabled: false, placeholder: "Search...", size: "small", sx: { width: '336px', height: '37px', backgroundColor: 'white' }, onChange: e => setSearchQuery(e.target.value), startAdornment: _jsx(SearchIcon, {}) }), _jsx(Button, { variant: "contained", startIcon: _jsx(AutoAwesomeIcon, {}), onClick: () => navigateToPreTestingPage('new'), children: "New AI Creative Study" })] }), _jsx(CreativeTable, { filterString: searchQuery, handleRowClick: navigateToPreTestingPage })] }));
};
